// 掲載書類編集完了
import React, { useEffect } from 'react';
import { render } from 'react-dom';
import { handleBrowserBack } from '../../../BrowserBack';
import { maintenance_type } from '../../../Const';
import Maintenance from '../../../molecules/Maintenance';

const DisplayedDocumentComplete: React.FC = () => {
  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
  }, []);

  return (
    <Maintenance active={maintenance_type.displayed_documents}>
      <div className="page-title">掲載書類編集完了</div>
      <div className="complete-message">掲載書類の編集が完了しました。</div>
      <div className="footer-btn">
        <a
          href={`${location.origin}${process.env.MIX_MOCK_URL}/maintenance/displayed_documents`}
          className="btn btn-mini btn-success"
        >
          次へ
        </a>
      </div>
    </Maintenance>
  );
};

if (document.getElementById('displayed-document-complete')) {
  render(<DisplayedDocumentComplete />, document.getElementById('displayed-document-complete'));
}
